import "./privacy.css";

import termsPDF from "../../assets/privacy/terms-of-service.pdf";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/Footer/Footer";
import DocumentView from "../../components/DocumentView/DocumentView";

export default function TermsPage() {
  return (
    <section className="privacy-bg">
      <Navbar />
      <DocumentView document={termsPDF} />
      <Footer />
    </section>
  );
}
